import { useEffect } from 'react'

// Nhận phiên đăng nhập từ app Desktop (Electron "Soạn bài") khi mở link ebook ở Chrome NGOÀI
// (vd bấm "Làm bài" xem trắc nghiệm PMaker) — Chrome ngoài là trình duyệt tách biệt, không có
// sẵn session của app, nếu không nhận token ở đây thì nộp bài trắc nghiệm sẽ luôn bị 401.
// Ngược chiều với DesktopAuthBridge (đưa token TỪ Chrome VỀ app).
export default function DesktopTokenReceiver() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('desktopToken')
    if (!token) return

    localStorage.setItem('auth_token', token)
    localStorage.setItem('jwt_token', token)
    localStorage.setItem('is_authenticated', 'true')

    const userJson = params.get('desktopUser')
    if (userJson) {
      try {
        const user = JSON.parse(userJson)
        localStorage.setItem('auth_user', userJson)
        if (user?.id != null) localStorage.setItem('user_id', String(user.id))
      } catch { /* ignore */ }
    }
    const profileJson = params.get('desktopProfile')
    if (profileJson) localStorage.setItem('user_profile', profileJson)

    // Xoá tham số nhạy cảm khỏi URL rồi reload để AuthContext khởi tạo lại với token vừa ghi.
    params.delete('desktopToken')
    params.delete('desktopUser')
    params.delete('desktopProfile')
    const query = params.toString()
    const clean = window.location.pathname + (query ? `?${query}` : '') + window.location.hash
    window.location.replace(clean)
  }, [])

  return null
}
